import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import {
    ORFButton
    , OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
} from '../../../../../../common/forms/order-request-form.component';
import { newQuotationActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-quotation.reducer";
import '../../new-circuit/exhibit-a/wireline-location-form.component.css';


class QuotationLocationForm extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.getQuotationFormData();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const {
            //component props
            onClickCancel
            , nextAction
            // form
            , quotationLocationFormA
            // reducer action
            , onCountrySelect
        } = this.props;

        const { countryOptions } = this.props.quotationRequest;

        return (
            <div>
                <Form method="post" role="form"
                    model="quotationLocationFormA"
                    onSubmit={nextAction}
                >
                    <div >
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('country')} *`}
                                    options={countryOptions}
                                    placeholder={this.toLocaleLanguage('select_a_country')}
                                    fieldProp='.countryCode'
                                    value={quotationLocationFormA.countryCode}
                                    onChangeAction={onCountrySelect}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea
                                    label={`${this.toLocaleLanguage('address')} *`}
                                    fieldProp='.quotationAddress'
                                    value={quotationLocationFormA.quotationAddress}
                                    maxLength="255"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea
                                    label={this.toLocaleLanguage('address_2_p2p')}
                                    fieldProp='.quotationAddress2'
                                    value={quotationLocationFormA.quotationAddress2}
                                    maxLength="255"
                                />
                            </Col>
                        </Row>
                        <div className="request-button-continer">
                            <div className="bottom-left">
                                <ORFButton
                                    label={this.toLocaleLanguage('modal_close_cancel_button')}
                                    variant={"light"}
                                    action={onClickCancel}
                                />
                            </div>
                            <div className="bottom-right">
                                <div>
                                    <ORFButton
                                        label={this.toLocaleLanguage('next_button')}
                                        variant={"primary"}
                                        type={"submit"}
                                        disabled={quotationLocationFormA.countryCode == ''
                                            || quotationLocationFormA.quotationAddress == ''}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};
export default connect(
    state => {
        const { quotationRequest, translation } = state;
        const { quotationLocationFormA } = state.form;
        return {
            quotationRequest
            , quotationLocationFormA
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newQuotationActions),
            dispatch
        )
)(QuotationLocationForm);
